import { DownloadIcon } from "@chakra-ui/icons";
import { ButtonProps, useToast } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaButton, useFrontendSetting } from "@nens/ranalib";
import { downloadFile } from "@nens/shared-utils";

export const DownloadDesktopClientButton = (props: ButtonProps) => {
  const { desktopClientVersion } = useFrontendSetting();
  const toast = useToast();
  const intl = useIntl();

  return (
    <RanaButton
      onClick={() => {
        const fileName = `RanaDesktopClient-OSGeo4W-${desktopClientVersion}-Setup-x86_64.exe`;
        downloadFile(`https://downloads.ranawaterintelligence.com/${fileName}`, fileName);
        toast({
          description: intl.formatMessage(
            {
              id: "success.started_download",
              defaultMessage: "Started download of {fileName}.",
            },
            { fileName }
          ),
        });
      }}
      variant="secondary"
      leftIcon={<DownloadIcon />}
      {...props}
    >
      <FormattedMessage
        id="dashboard.download_now"
        defaultMessage="Download Rana Desktop Client (1.7GB)"
      />
    </RanaButton>
  );
};
